<template>
    <v-app-bar :elevation="2">
        <template v-slot:prepend>
            <v-btn v-if="back" class="black-btn" :href="back">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
                <span>&nbsp;Back </span>
            </v-btn>
            <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
        </template>

        <span class="title" v-html="displayTitle"></span>

        <template v-slot:append>
            <v-btn class="btn btn-primary blue-btn" href="/auth/logout">Logout</v-btn>

            <!-- <v-btn icon="mdi-magnify"></v-btn> -->

            <!-- <v-btn icon="mdi-dots-vertical"></v-btn> -->
        </template>
    </v-app-bar>
</template>
<script src="./appbar.ts"></script>